import { SorterResult } from 'antd/lib/table/interface';

import { TableWithForm, TitledContainer } from 'components';

import { useGetHeaders, useMemoState, useTableSearchParams } from 'hooks';

import { OfferDashboardDto } from 'codegen';

import { NewOfferButton } from './components';
import { columns, handleOffersTableChange } from './offersHelpers';

export const Offers = () => {
  const [sortOrderInfo, setSortOrderInfo] = useMemoState<SorterResult<OfferDashboardDto>>({ field: 'order', order: 'descend' });

  const headers = useGetHeaders();

  const { setSearchParams, defaultTableParams } = useTableSearchParams({ defaultSize: 10 });

  return (
    <TitledContainer
      title='Offers'
      titleExtraNode={<NewOfferButton />}
    >
      <TableWithForm
        horizontalScroll
        id='all-offers-table'
        columns={columns(sortOrderInfo)}
        defaultTableParams={defaultTableParams}
        onTableChange={handleOffersTableChange(headers, setSearchParams, setSortOrderInfo)}
      />
    </TitledContainer>
  );
};
